import { useMemo } from "react";
import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { useGrupoAcessoListaViewModel } from "../../viewModels/grupos_acesso_lista_view_model";
import { Header } from "./components/header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GenerateColumnsDefinition } from "./table_column";

import RefreshButton from "../../../../../common/components/refresh_button";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import AlertError from "../../../../../common/components/alert_error";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { GrupoAcesso } from "../../../domain/models/grupo_acesso";

/**
 * GrupoAcessoLista
 */

export const GrupoAcessoLista = () => {
  const viewModel = useGrupoAcessoListaViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateColumnsDefinition({
      handleActionEditAccessGroup: viewModel.handleDataGridActionEdit,
      handleActionDeleteAccessGroup: viewModel.handleDataGridActionDelete,
    });
  }, [viewModel.handleDataGridActionEdit, viewModel.handleDataGridActionDelete]);


  return (
    <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
      <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
        <Link underline="hover" color="inherit" >
          Administração
        </Link>
        <Typography className="text-primary-green">
          Grupos de Acesso
        </Typography>
      </Breadcrumbs>

      <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">Grupos de Acesso</h1>
          <RefreshButton onClick={viewModel.handleReload} />
        </div>

        <div className="w-full justify-end flex gap-2">
          <div className="w-[180px] ">
            <PrimaryButton
              startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
              onClick={viewModel.handleNewGroup}>
              Novo Grupo
            </PrimaryButton>
          </div>
        </div>
      </div>
      {
        viewModel.errorMessage !== undefined
          ? (
            <div className="w-full">
              <AlertError
                messageErro={viewModel.errorMessage}
                onTryAgain={viewModel.handleReload} />
            </div>
          ) : (
            <>
              <Header
                name={viewModel.filters.name}
                description={viewModel.filters.description}
                status={viewModel.filters.status}
                handleNameChange={viewModel.handleNameFilterChange}
                handleDescriptionChange={viewModel.handleDescriptionFilterChange}
                handleStatusSelection={viewModel.handleStatusFilterChange}
                handleClearFilters={viewModel.handleClearFilters} />

              {
                viewModel.internalErrorMessage !== undefined &&
                <div className="w-full">
                  <AlertError
                    messageErro={viewModel.internalErrorMessage}
                    onTryAgain={viewModel.handleReload}
                    onClose={() => viewModel.setInternalErrorMessage(undefined)} />
                </div>
              }

              <Stack spacing={0}>
                <div className="w-full flex flex-row justify-between items-center">
                  {/* <LegendComponent>
                    <LegendItemComponent
                      icon={<LegendIcon color='green' title='A' />}
                      label='Ativo' />

                    <LegendItemComponent
                      icon={<LegendIcon color='red' title='B' />}
                      label='Bloqueado' />
                  </LegendComponent> */}

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />

                </div>

                <StyledDataGrid
                  tableName="grupos_acesso_lista"
                  disableColumnMenu={false}
                  showToolbar={true}
                  disableRowSelectionOnClick={true}
                  getRowId={(row: GrupoAcesso) => row.idGrupoAcesso}
                  columns={columnsDefinition}
                  loading={viewModel.loading}
                  checkboxSelection={false}
                  rows={viewModel.gruposAcessoLista}
                  rowCount={viewModel.gruposAcessoLista.length}
                  pageSizeOptions={[10, 25, 50, 100]}
                  paginationMode="server"
                  paginationModel={{
                    page: viewModel.pagination.page,
                    pageSize: viewModel.pagination.rowsPerPage,
                  }}

                // pinnedColumns={{
                //   left: ["__check__"],
                //   right: ['idUsuario'],
                // }}
                />




                <TablePagination
                  component="div"
                  count={viewModel.pagination.totalItems}
                  page={viewModel.pagination.page - 1}
                  onPageChange={(_, p) => viewModel.handlePageChange(p)}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  rowsPerPage={viewModel.pagination.rowsPerPage}
                  onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />

              </Stack>
            </>
          )
      }

      <DeleteDialog
        open={viewModel.dialogDeleteOpen}
        saving={false}
        onClose={() => viewModel.setDialogDeleteOpen(false)}
        title={`Você realmente deseja excluir o grupo ${viewModel.selectedAccessGroup?.nomeGrupo}?`}
        onDelete={viewModel.handleDelete} />

    </div>
  );
}